// const mainNavBtnBurger = document.querySelector(".main-nav__btn-burger");

// const handleOpenBurger = () => {
//   mainNavBtnBurger.classList.remove
// }

// mainNavBtnBurger.addEventListener('click', handleOpenBurger);
